module.exports = __webpack_public_path__ + "img/lexile.bd750e76.png";